var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_2316)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_2316",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 0H0V77H77V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5Z",
    fill: "#4967D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7577 13L33.2461 4.46875H34.3065L32.8184 13H31.7577ZM33.9551 13L35.4492 4.46875H36.5098L35.0155 13H33.9551ZM37.3828 7.89648H31.2831V6.90625H37.3828V7.89648ZM36.9375 10.5977H30.8438V9.61328H36.9375V10.5977ZM44.0331 11.6816V13H38.1973V11.875L40.957 8.91602C41.2344 8.60742 41.4531 8.33594 41.6133 8.10156C41.7734 7.86328 41.8887 7.65039 41.959 7.46289C42.0332 7.27148 42.0703 7.08984 42.0703 6.91797C42.0703 6.66016 42.0272 6.43945 41.9413 6.25586C41.8554 6.06836 41.7285 5.92383 41.5605 5.82227C41.3965 5.7207 41.1933 5.66992 40.9511 5.66992C40.6933 5.66992 40.4706 5.73242 40.2831 5.85742C40.0995 5.98242 39.959 6.15625 39.8613 6.37891C39.7676 6.60156 39.7206 6.85352 39.7206 7.13477H38.0273C38.0273 6.62695 38.1483 6.16211 38.3905 5.74023C38.6327 5.31445 38.9746 4.97656 39.416 4.72656C39.8574 4.47266 40.3809 4.3457 40.9863 4.3457C41.584 4.3457 42.0879 4.44336 42.498 4.63867C42.9121 4.83008 43.2246 5.10742 43.4355 5.4707C43.6504 5.83008 43.7578 6.25977 43.7578 6.75977C43.7578 7.04102 43.7129 7.31641 43.623 7.58594C43.5332 7.85156 43.4043 8.11719 43.2363 8.38281C43.0723 8.64453 42.8729 8.91016 42.6386 9.17969C42.4042 9.44922 42.1445 9.72852 41.8594 10.0176L40.3769 11.6816H44.0331Z",
    fill: "#D6CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6239 47.0712C62.7791 47.3815 62.8308 47.6402 62.8308 47.8988C62.8308 48.1747 62.7791 48.4506 62.6756 48.7264C62.6066 48.9678 62.4859 49.192 62.3135 49.3989C62.1583 49.6576 61.9514 49.8645 61.641 50.0196C61.5376 49.7093 61.5376 49.3989 61.5376 49.1403C61.5376 48.8644 61.5893 48.6058 61.6928 48.3644C61.7617 48.123 61.8652 47.8988 62.0031 47.6919C62.1583 47.485 62.3652 47.2264 62.6239 47.0712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21 48.4678C62.1411 48.7092 62.0721 48.9678 62.0031 49.2437C61.8997 49.5196 61.8134 49.7782 61.7445 50.0196C61.6927 50.0713 61.641 50.1231 61.641 50.1231C61.5893 50.0713 61.5376 50.0196 61.5893 49.9679C61.6928 49.7265 61.7962 49.4678 61.8997 49.192C62.0031 48.9506 62.1066 48.7092 62.21 48.4678Z",
    fill: "url(#paint0_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2959 51.9335C57.658 52.037 57.9166 52.2439 58.1235 52.3991C58.3649 52.606 58.5546 52.8301 58.6926 53.0715C58.865 53.3474 59.0029 53.6233 59.1064 53.8992C59.1581 54.2095 59.2098 54.5199 59.1581 54.9337C58.796 54.8303 58.5891 54.6234 58.3305 54.4165C58.1235 54.2095 57.9511 53.9854 57.8132 53.744C57.6407 53.4681 57.5201 53.1922 57.4511 52.9164C57.3476 52.606 57.2959 52.2956 57.2959 51.9335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.02 53.0198C58.4338 53.6061 58.8477 54.2268 59.2615 54.882C59.3132 54.9337 59.3132 54.9855 59.2098 55.0372C59.158 55.0889 59.0546 55.0889 59.0546 55.0372C58.7097 54.3475 58.3649 53.6751 58.02 53.0198Z",
    fill: "url(#paint1_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7791 55.0372C62.417 55.2958 62.1067 55.451 61.7963 55.5545C61.4515 55.6234 61.1411 55.6579 60.8652 55.6579C60.5548 55.6234 60.2617 55.5545 59.9858 55.451C59.6755 55.3475 59.4168 55.1924 59.1582 54.9337C59.5203 54.7268 59.8307 54.6234 60.141 54.5716C60.4514 54.4682 60.7618 54.4164 61.0721 54.4164C61.348 54.4164 61.6411 54.4682 61.9515 54.5716C62.2101 54.6751 62.5205 54.7785 62.7791 55.0372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4341 55.0372C60.6754 55.0717 59.9168 55.0889 59.1581 55.0889C59.0547 55.0889 59.0029 55.0372 59.0029 54.9337C59.0547 54.882 59.1064 54.7785 59.1581 54.8303C59.1926 54.8303 59.2098 54.8303 59.2098 54.8303C59.934 54.9337 60.6754 55.0027 61.4341 55.0372Z",
    fill: "url(#paint2_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7958 53.175C56.2097 53.3302 56.4683 53.5371 56.7269 53.7441C56.9683 53.9855 57.158 54.2614 57.2959 54.5718C57.4684 54.8477 57.5891 55.1753 57.658 55.5546C57.7098 55.865 57.7098 56.2788 57.6063 56.6926C57.2442 56.5374 56.9856 56.2787 56.7787 56.0201C56.5373 55.7787 56.3476 55.5029 56.2097 55.1925C56.0717 54.9166 55.951 54.6062 55.8476 54.2613C55.7958 53.8992 55.7441 53.5371 55.7958 53.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52 54.4165C56.9338 55.1407 57.3477 55.8821 57.7615 56.6408C57.8132 56.6925 57.7615 56.796 57.7098 56.8477C57.6063 56.8994 57.5028 56.8477 57.5028 56.796C57.1925 55.9683 56.8649 55.1752 56.52 54.4165Z",
    fill: "url(#paint3_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.693 57.1581C61.2791 57.4167 60.9171 57.5202 60.555 57.6236C60.1756 57.6926 59.8135 57.6926 59.4687 57.6236C59.1238 57.5891 58.7962 57.5029 58.4858 57.365C58.2272 57.2098 57.9168 57.0546 57.6582 56.6925C58.0203 56.4856 58.3824 56.4339 58.7445 56.3304C59.1238 56.2959 59.4859 56.2959 59.8308 56.3304C60.1411 56.3304 60.4687 56.3994 60.8136 56.5373C61.124 56.6408 61.4343 56.8477 61.693 57.1581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1927 57.0546C59.3306 57.0201 58.4685 56.9512 57.6063 56.8477C57.5029 56.8477 57.4512 56.796 57.4512 56.6925C57.5029 56.5891 57.5546 56.5374 57.6581 56.5374C58.5202 56.7443 59.3651 56.9167 60.1927 57.0546Z",
    fill: "url(#paint4_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0887 54.313C54.5025 54.5717 54.7613 54.8303 55.0199 55.1407C55.2613 55.451 55.451 55.7787 55.5889 56.1235C55.7269 56.4684 55.813 56.8477 55.8475 57.2615C55.8475 57.6753 55.8475 58.0892 55.6405 58.5547C55.2267 58.3478 55.0198 58.0374 54.7612 57.6754C54.5543 57.365 54.3818 57.0374 54.2439 56.6925C54.1059 56.3477 54.0198 55.9683 53.9854 55.5545C53.9854 55.1924 53.9853 54.7786 54.0887 54.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7095 55.8132C55.0888 56.7098 55.4682 57.6064 55.8475 58.503C55.8475 58.6065 55.7958 58.7099 55.6923 58.7616C55.6406 58.7616 55.5371 58.7617 55.4854 58.6582C55.244 57.6926 54.9854 56.7443 54.7095 55.8132Z",
    fill: "url(#paint5_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1927 59.641C59.6754 59.8996 59.2616 59.9514 58.796 60.0031C58.3822 60.0376 57.9857 60.0031 57.6063 59.8996C57.227 59.7962 56.8821 59.641 56.5718 59.4341C56.2097 59.2272 55.8993 58.9685 55.6924 58.6064C56.1579 58.3995 56.5718 58.3478 56.9856 58.3478C57.3994 58.3133 57.796 58.3306 58.1753 58.3995C58.5547 58.503 58.9168 58.6409 59.2616 58.8134C59.572 59.0203 59.9341 59.2272 60.1927 59.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5376 59.2789C57.5375 59.141 56.5547 58.9685 55.5891 58.7616C55.4856 58.7616 55.4339 58.6582 55.4856 58.5547C55.5374 58.4513 55.6408 58.3995 55.6925 58.3995C55.727 58.3995 55.7443 58.3995 55.7443 58.3995C56.6409 58.7444 57.572 59.0375 58.5376 59.2789Z",
    fill: "url(#paint6_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5887 55.9166C52.8991 56.2269 53.106 56.589 53.2612 56.9511C53.3992 57.296 53.4854 57.6581 53.5199 58.0374C53.5888 58.4167 53.5716 58.8133 53.4681 59.2272C53.4164 59.5892 53.2612 60.0031 53.0026 60.4169C52.6405 60.1065 52.4853 59.7444 52.3301 59.3823C52.2267 59.003 52.1577 58.6236 52.1232 58.2443C52.0887 57.865 52.106 57.4856 52.1749 57.1063C52.2267 56.6925 52.3301 56.3304 52.5887 55.9166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7954 57.5201C52.9334 58.4857 53.054 59.4513 53.1575 60.4169C53.1575 60.5204 53.1058 60.5721 53.0023 60.6238C52.8989 60.6238 52.7954 60.5721 52.7954 60.4686C52.8299 59.4686 52.8299 58.4857 52.7954 57.5201Z",
    fill: "url(#paint7_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0889 62.6412C56.5199 62.7446 56.1061 62.6929 55.6406 62.6412C55.2267 62.5377 54.8646 62.3998 54.5543 62.2274C54.2094 62.0205 53.899 61.7791 53.6232 61.5032C53.3645 61.2445 53.1576 60.8825 53.0024 60.4686C53.5197 60.4169 53.9335 60.4686 54.3474 60.5204C54.7267 60.6238 55.0888 60.7618 55.4336 60.9342C55.7785 61.1066 56.1061 61.3307 56.4165 61.6066C56.6751 61.8653 56.9337 62.1756 57.0889 62.6412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.589 61.8653C54.6579 61.486 53.7613 61.072 52.8991 60.6237C52.7957 60.572 52.744 60.4686 52.8474 60.3652C52.8991 60.2617 53.0026 60.2617 53.106 60.3135C53.8992 60.8652 54.7269 61.3825 55.589 61.8653Z",
    fill: "url(#paint8_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4341 50.5369C58.7962 50.5887 59.0031 50.7438 59.2617 50.899C59.4686 51.037 59.6583 51.2094 59.8307 51.4163C59.9687 51.6232 60.0894 51.8646 60.1928 52.1405C60.2445 52.3991 60.2963 52.7095 60.2446 53.0716C59.9342 53.0199 59.6755 52.8647 59.4686 52.7095C59.2617 52.5371 59.0893 52.3474 58.9514 52.1405C58.7789 51.9336 58.6582 51.6922 58.5893 51.4163C58.4858 51.1577 58.4341 50.899 58.4341 50.5369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1064 51.4163C59.5548 51.9336 59.9858 52.4509 60.3996 52.9682C60.3996 53.0199 60.3996 53.1233 60.3479 53.1751C60.2962 53.2268 60.1927 53.2268 60.141 53.1751C59.8306 52.5888 59.4858 52.0026 59.1064 51.4163Z",
    fill: "url(#paint9_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4518 52.9681C63.1931 53.2268 62.8828 53.3819 62.6241 53.4854C62.3483 53.5888 62.0724 53.6406 61.7965 53.6406C61.5206 53.6406 61.262 53.6061 61.0206 53.5371C60.7619 53.4337 60.5033 53.3302 60.2964 53.0716C60.555 52.8646 60.8137 52.7095 61.124 52.606C61.3654 52.5026 61.6241 52.4508 61.8999 52.4508C62.1758 52.4164 62.4345 52.4336 62.6758 52.5026C62.9345 52.606 63.1931 52.7095 63.4518 52.9681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3137 53.0198C61.624 53.1233 60.9343 53.1923 60.2446 53.2268C60.1928 53.2268 60.1411 53.175 60.1411 53.0716C60.1411 53.0198 60.1929 52.9681 60.2963 52.9164C60.9515 52.9854 61.624 53.0198 62.3137 53.0198Z",
    fill: "url(#paint10_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4687 49.1403C59.7791 49.1403 59.986 49.2437 60.1929 49.3472C60.3998 49.4506 60.5895 49.5886 60.7619 49.761C60.8998 49.9334 61.0033 50.1403 61.0723 50.3817C61.1757 50.6404 61.2274 50.899 61.1757 51.2094C60.8653 51.2094 60.6584 51.1059 60.4515 51.0024C60.2446 50.8645 60.0722 50.7093 59.9342 50.5369C59.7963 50.3645 59.6756 50.1576 59.5721 49.9162C59.5204 49.7093 59.417 49.4506 59.4687 49.1403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0894 49.8644C60.5032 50.2783 60.8998 50.7093 61.2791 51.1576C61.3308 51.2094 61.3308 51.2611 61.2791 51.3645C61.2274 51.4163 61.1239 51.4163 61.0722 51.3645C61.0722 51.3645 61.0722 51.3473 61.0722 51.3128C60.7618 50.83 60.4342 50.3472 60.0894 49.8644Z",
    fill: "url(#paint11_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9691 50.9507C63.7104 51.2611 63.5035 51.4163 63.2449 51.5197C63.0035 51.6232 62.7793 51.6922 62.5724 51.7267C62.331 51.7267 62.0896 51.6922 61.8483 51.6232C61.6413 51.5715 61.4344 51.468 61.1758 51.2611C61.4344 51.0025 61.6413 50.8473 61.9 50.7438C62.1414 50.6059 62.3655 50.5369 62.5724 50.5369C62.8138 50.5024 63.0552 50.5024 63.2966 50.5369C63.5035 50.6404 63.7104 50.6921 63.9691 50.9507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9345 51.0542C62.3482 51.1921 61.762 51.2956 61.1757 51.3646C61.124 51.4163 61.0723 51.3646 61.0723 51.2611C61.0723 51.1577 61.124 51.1059 61.1757 51.1059C61.762 51.1059 62.3482 51.0887 62.9345 51.0542Z",
    fill: "url(#paint12_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6928 50.1231C61.3824 51.2611 60.8652 52.3991 60.2444 53.4337C59.6754 54.4682 58.9512 55.5028 58.1753 56.3822C57.3994 57.3133 56.5718 58.1926 55.5889 58.9168C54.6578 59.7445 53.6233 60.3652 52.5887 61.0377C52.4335 61.0894 52.2266 61.0377 52.1749 60.8825C52.0715 60.7273 52.1232 60.5204 52.2784 60.4687C52.2784 60.4687 52.2784 60.4514 52.2784 60.4169C53.3129 59.8479 54.3475 59.2789 55.2786 58.503C56.2097 57.8305 57.089 57.0029 57.865 56.1235C58.6926 55.2442 59.4168 54.3131 60.0375 53.2785C60.6583 52.2957 61.1755 51.2094 61.5376 50.0714C61.5721 50.0369 61.6066 50.0197 61.6411 50.0197C61.6928 50.0197 61.6928 50.0714 61.6928 50.1231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3451 47.0712C15.1899 47.3815 15.1382 47.6402 15.1382 47.8988C15.1382 48.1747 15.1899 48.4506 15.2934 48.7264C15.3623 48.9678 15.483 49.192 15.6555 49.3989C15.8106 49.6576 16.0176 49.8645 16.2762 50.0196C16.4314 49.7093 16.4314 49.3989 16.4314 49.1403C16.3969 48.8644 16.3452 48.6058 16.2762 48.3644C16.2072 48.123 16.0865 47.8988 15.9141 47.6919C15.7589 47.485 15.6037 47.2264 15.3451 47.0712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7588 48.4678C15.8278 48.7092 15.8967 48.9678 15.9657 49.2437C16.0347 49.5196 16.1209 49.7782 16.2243 50.0196C16.2243 50.0713 16.2761 50.1231 16.3278 50.1231C16.3795 50.0713 16.3795 50.0196 16.3795 49.9679C16.2761 49.7265 16.1726 49.4678 16.0692 49.192C15.9657 48.9506 15.8622 48.7092 15.7588 48.4678Z",
    fill: "url(#paint13_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6214 51.9335C20.3111 52.037 20.0524 52.2439 19.7938 52.3991C19.5869 52.606 19.3972 52.8301 19.2248 53.0715C19.0869 53.3474 18.9662 53.6233 18.8627 53.8992C18.811 54.2095 18.7592 54.5199 18.811 54.9337C19.1213 54.8303 19.38 54.6234 19.5869 54.4165C19.7938 54.2095 19.9835 53.9854 20.1559 53.744C20.2938 53.4681 20.4145 53.1922 20.518 52.9164C20.5697 52.606 20.6732 52.2956 20.6214 51.9335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.949 53.0198C19.5006 53.6061 19.0696 54.2268 18.6558 54.882C18.6558 54.9337 18.6557 54.9855 18.7075 55.0372C18.8109 55.0889 18.8627 55.0889 18.9144 55.0372C19.2248 54.3475 19.5696 53.6751 19.949 53.0198Z",
    fill: "url(#paint14_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1899 55.0372C15.5003 55.2958 15.8624 55.451 16.1728 55.5545C16.4831 55.6234 16.7935 55.6579 17.1039 55.6579C17.4142 55.6234 17.7074 55.5545 17.9832 55.451C18.2419 55.3475 18.5005 55.1924 18.7592 54.9337C18.4488 54.7268 18.1384 54.6234 17.8281 54.5716C17.5177 54.4682 17.2073 54.4164 16.8969 54.4164C16.5866 54.4164 16.2935 54.4682 16.0176 54.5716C15.7072 54.6751 15.4486 54.7785 15.1899 55.0372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4834 55.0372C17.2766 55.0717 18.0525 55.0889 18.8111 55.0889C18.8629 55.0889 18.9146 55.0372 18.9146 54.9337C18.9146 54.882 18.8629 54.7785 18.7594 54.8303C18.0007 54.9337 17.2421 55.0027 16.4834 55.0372Z",
    fill: "url(#paint15_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1207 53.175C21.7586 53.3302 21.5 53.5371 21.2413 53.7441C20.9999 53.9855 20.8103 54.2614 20.6723 54.5718C20.4999 54.8477 20.3792 55.1753 20.3102 55.5546C20.2585 55.865 20.2068 56.2788 20.3102 56.6926C20.724 56.5374 20.931 56.2787 21.1896 56.0201C21.3965 55.7787 21.5862 55.5029 21.7586 55.1925C21.8965 54.9166 22 54.6062 22.069 54.2613C22.1724 53.8992 22.2241 53.5371 22.1207 53.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4483 54.4165C21 55.1407 20.5862 55.8821 20.2068 56.6408C20.1551 56.6925 20.1551 56.796 20.2585 56.8477C20.3103 56.8994 20.4137 56.8477 20.4655 56.796C20.7758 55.9683 21.1034 55.1752 21.4483 54.4165Z",
    fill: "url(#paint16_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2241 57.1581C16.6379 57.4167 17.0518 57.5202 17.4139 57.6236C17.7932 57.6926 18.138 57.6926 18.4484 57.6236C18.7933 57.5891 19.1209 57.5029 19.4312 57.365C19.7416 57.2098 20.052 57.0546 20.3106 56.6925C19.8968 56.4856 19.5347 56.4339 19.1726 56.3304C18.8278 56.2959 18.4829 56.2959 18.1381 56.3304C17.7932 56.3304 17.4656 56.3994 17.1552 56.5373C16.8448 56.6408 16.5345 56.8477 16.2241 57.1581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7241 57.0546C18.6207 57.0201 19.5001 56.9512 20.3622 56.8477C20.414 56.8477 20.4657 56.796 20.4657 56.6925C20.4657 56.5891 20.3622 56.5374 20.3105 56.5374C20.276 56.5374 20.2588 56.5374 20.2588 56.5374C19.4311 56.7443 18.5862 56.9167 17.7241 57.0546Z",
    fill: "url(#paint17_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8793 54.313C23.4655 54.5717 23.1552 54.8303 22.9483 55.1407C22.7069 55.451 22.5172 55.7787 22.3792 56.1235C22.2413 56.4684 22.1551 56.8477 22.1206 57.2615C22.1206 57.6753 22.1206 58.0892 22.2758 58.5547C22.6896 58.3478 22.9482 58.0374 23.1552 57.6754C23.3966 57.365 23.569 57.0374 23.6724 56.6925C23.8104 56.3477 23.8966 55.9683 23.9311 55.5545C23.9828 55.1924 23.9828 54.7786 23.8793 54.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2589 55.8132C22.8451 56.7098 22.4657 57.6064 22.1209 58.503C22.0692 58.6065 22.1209 58.7099 22.2243 58.7616C22.3278 58.7616 22.4313 58.7617 22.483 58.6582C22.6899 57.6926 22.9485 56.7443 23.2589 55.8132Z",
    fill: "url(#paint18_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7759 59.641C18.2414 59.8996 18.707 59.9514 19.1208 60.0031C19.5346 60.0376 19.9312 60.0031 20.3105 59.8996C20.6899 59.7962 21.052 59.641 21.3968 59.4341C21.7072 59.2272 22.0176 58.9685 22.2762 58.6064C21.8106 58.3995 21.3968 58.3478 20.983 58.3478C20.5692 58.3133 20.1726 58.3306 19.7933 58.3995C19.4139 58.503 19.0518 58.6409 18.707 58.8134C18.3449 59.0203 18.0345 59.2272 17.7759 59.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4312 59.2789C20.3967 59.141 21.3623 58.9685 22.3279 58.7616C22.4313 58.7616 22.4831 58.6582 22.4831 58.5547C22.4314 58.4513 22.3279 58.3995 22.2244 58.3995C21.2933 58.7444 20.3623 59.0375 19.4312 59.2789Z",
    fill: "url(#paint19_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.38 55.9166C25.0179 56.2269 24.8627 56.589 24.6558 56.9511C24.5178 57.296 24.4316 57.6581 24.3971 58.0374C24.3626 58.4167 24.3799 58.8133 24.4489 59.2272C24.5523 59.5892 24.6558 60.0031 24.9661 60.4169C25.2765 60.1065 25.4317 59.7444 25.5869 59.3823C25.7248 59.003 25.811 58.6236 25.8455 58.2443C25.8455 57.865 25.8283 57.4856 25.7938 57.1063C25.6903 56.6925 25.5869 56.3304 25.38 55.9166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1731 57.5201C25.0007 58.4857 24.8627 59.4513 24.7593 60.4169C24.7593 60.5204 24.8627 60.5721 24.9662 60.6238C25.0696 60.6238 25.1214 60.5721 25.1731 60.4686C25.1386 59.4686 25.1386 58.4857 25.1731 57.5201Z",
    fill: "url(#paint20_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8799 62.6412C21.3972 62.7446 21.8627 62.6929 22.2765 62.6412C22.6904 62.5377 23.0697 62.3998 23.4145 62.2274C23.7594 62.0205 24.0698 61.7791 24.3456 61.5032C24.6043 61.2445 24.8112 60.8825 24.9664 60.4686C24.4491 60.4169 24.0353 60.4686 23.6214 60.5204C23.2076 60.6238 22.8283 60.7618 22.4834 60.9342C22.1386 61.1066 21.8282 61.3307 21.5523 61.6066C21.2937 61.8653 21.0351 62.1756 20.8799 62.6412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3799 61.8653C23.311 61.486 24.2076 61.072 25.0697 60.6237C25.1732 60.572 25.1732 60.4686 25.1215 60.3652C25.0697 60.2617 24.9663 60.2617 24.8628 60.3135C24.0352 60.8652 23.2075 61.3825 22.3799 61.8653Z",
    fill: "url(#paint21_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4826 50.5369C19.1723 50.5887 18.9136 50.7438 18.7067 50.899C18.4653 51.037 18.2756 51.2094 18.1377 51.4163C17.9998 51.6232 17.8791 51.8646 17.7756 52.1405C17.6722 52.3991 17.6204 52.7095 17.6721 53.0716C18.0342 53.0199 18.2412 52.8647 18.4481 52.7095C18.6895 52.5371 18.8791 52.3474 19.0171 52.1405C19.155 51.9336 19.2757 51.6922 19.3792 51.4163C19.4309 51.1577 19.5343 50.899 19.4826 50.5369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8101 51.4163C18.3963 51.9336 17.9825 52.4509 17.5686 52.9682C17.5169 53.0199 17.5169 53.1233 17.6204 53.1751C17.6721 53.2268 17.7238 53.2268 17.7756 53.1751C18.1204 52.5888 18.4653 52.0026 18.8101 51.4163Z",
    fill: "url(#paint22_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4653 52.9681C14.7757 53.2268 15.0343 53.3819 15.3447 53.4854C15.6206 53.5888 15.8792 53.6406 16.1206 53.6406C16.3965 53.6406 16.6724 53.6061 16.9483 53.5371C17.1552 53.4337 17.4138 53.3302 17.6724 53.0716C17.3621 52.8646 17.1034 52.7095 16.8448 52.606C16.5689 52.5026 16.293 52.4508 16.0172 52.4508C15.7758 52.4164 15.5171 52.4336 15.2412 52.5026C14.9826 52.606 14.724 52.7095 14.4653 52.9681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6548 53.0198C16.3445 53.1233 17.0169 53.1923 17.6722 53.2268C17.7756 53.2268 17.8274 53.175 17.8274 53.0716C17.8274 53.0198 17.7756 52.9681 17.6722 52.9164C16.9825 52.9854 16.31 53.0198 15.6548 53.0198Z",
    fill: "url(#paint23_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 49.1403C18.1896 49.1403 17.9309 49.2437 17.724 49.3472C17.5171 49.4506 17.3447 49.5886 17.2068 49.761C17.0688 49.9334 16.9481 50.1403 16.8447 50.3817C16.7929 50.6404 16.7412 50.899 16.7412 51.2094C17.1033 51.2094 17.3102 51.1059 17.5171 51.0024C17.724 50.8645 17.8965 50.7093 18.0344 50.5369C18.1723 50.3645 18.2758 50.1576 18.3448 49.9162C18.4482 49.7093 18.4999 49.4506 18.4999 49.1403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8277 49.8644C17.4484 50.2783 17.0518 50.7093 16.638 51.1576C16.5863 51.2094 16.5863 51.2611 16.6897 51.3645C16.7414 51.4163 16.7932 51.4163 16.8449 51.3645C16.8449 51.3645 16.8621 51.3473 16.8966 51.3128C17.207 50.83 17.5174 50.3472 17.8277 49.8644Z",
    fill: "url(#paint24_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 50.9507C14.2069 51.2611 14.4655 51.4163 14.6725 51.5197C14.9138 51.6232 15.1552 51.6922 15.3966 51.7267C15.638 51.7267 15.8622 51.6922 16.0691 51.6232C16.276 51.5715 16.5347 51.468 16.7416 51.2611C16.5347 51.0025 16.276 50.8473 16.0691 50.7438C15.8277 50.6059 15.5863 50.5369 15.3449 50.5369C15.138 50.5024 14.9138 50.5024 14.6725 50.5369C14.4655 50.6404 14.2069 50.6921 14 50.9507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9829 51.0542C15.5692 51.1921 16.1554 51.2956 16.7416 51.3646C16.8451 51.4163 16.8968 51.3646 16.8968 51.2611C16.8968 51.1577 16.8451 51.1059 16.7416 51.1059C16.1554 51.1059 15.5692 51.0887 14.9829 51.0542Z",
    fill: "url(#paint25_radial_39_2316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3793 50.0714C16.7414 51.2094 17.3104 52.2957 17.9312 53.2785C18.5519 54.3131 19.2761 55.2442 20.052 56.1235C20.8796 57.0029 21.7073 57.8305 22.6901 58.503C23.6212 59.2789 24.604 59.8479 25.6386 60.4169H25.6903C25.8455 60.5204 25.8972 60.7273 25.7938 60.8825C25.6903 61.0377 25.5351 61.0894 25.3282 61.0377C24.2937 60.3652 23.2591 59.7445 22.328 58.9168C21.3969 58.1926 20.5693 57.3133 19.7416 56.3822C18.9657 55.5028 18.2933 54.4682 17.6725 53.4337C17.1035 52.3991 16.5862 51.2611 16.2759 50.1231C16.2759 50.0886 16.2931 50.0541 16.3276 50.0197L16.3793 50.0714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3124 61.2446V62.4343C44.3124 64.8138 42.7606 66.8312 40.588 67.5553C40.1225 68.1761 39.6569 68.4865 39.3466 68.6934L39.1914 71.5384L40.4846 73.7627C40.7949 73.7627 41.0019 73.9696 41.0019 74.2282V74.849H36.7085V74.2282C36.7085 73.9696 36.9671 73.7627 37.2257 73.7627L38.5189 71.5384L38.4155 68.6934C38.1051 68.4865 37.6396 68.1761 37.174 67.6588C34.9497 66.9863 33.2944 64.8655 33.2944 62.4343V61.2446H35.0532V60.21H42.6572V61.2446H44.3124ZM36.8119 67.0898C36.2946 66.3139 35.7256 65.2276 35.3118 63.6758C35.1739 63.0895 35.1049 62.5033 35.1049 61.917V61.6067H33.7082V62.4343C33.7082 64.5034 35.0014 66.3139 36.8119 67.0898ZM43.9503 61.6067H42.7089V61.917C42.7089 62.5033 42.6227 63.0895 42.4502 63.6758C42.0364 65.1759 41.5709 66.2622 41.0536 66.9864C42.7606 66.2104 43.9503 64.4517 43.9503 62.4343V61.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2949 69.7279L39.3466 68.6934H38.4155V69.7279H39.2949Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6572 61.6067H35.0532V61.1929H42.6572V61.6067Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6572 62.0722H35.0532V61.8136H42.6572V62.0722Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2608 74.849H36.2949V74.5386C36.2949 74.3834 36.4501 74.28 36.6053 74.28H41.0021C41.1573 74.28 41.2608 74.3834 41.2608 74.5386V74.849Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7778 62.6412L39.2433 63.9344H40.5882L39.5019 64.7621L39.9158 66.0553L38.7778 65.2794L37.6915 66.0553L38.1053 64.7621L36.9673 63.9344H38.3639L38.7778 62.6412Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0542 15C57.1409 18.9313 61.9516 26.4836 61.9516 35.1738C61.9516 37.1395 61.6929 39.0017 61.2274 40.8121",
    stroke: "#D6CFFF",
    strokeWidth: 1.08628,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4312 41.0708C15.9139 39.2086 15.6553 37.2429 15.6553 35.1738C15.6553 26.4836 20.466 18.9313 27.5526 15",
    stroke: "#D6CFFF",
    strokeWidth: 1.08628,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0029 35.1738C59.0029 46.347 49.9505 55.3993 38.7773 55.3993C27.6041 55.3993 18.6035 46.347 18.6035 35.1738C18.6035 24.0523 27.6041 15 38.7773 15C49.9505 15 59.0029 24.0523 59.0029 35.1738Z",
    fill: "#D6CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3997 35.1738C57.3997 45.4676 49.0716 53.7958 38.7778 53.7958C28.5357 53.7958 20.2075 45.4676 20.2075 35.1738C20.2075 24.9317 28.5357 16.6036 38.7778 16.6036C49.0716 16.6036 57.3997 24.9317 57.3997 35.1738Z",
    fill: "#8E8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7195 29.6092V26.7674C32.7195 25.2264 33.3184 23.7804 34.4099 22.6917C35.5014 21.603 36.9567 21 38.5016 21C40.0464 21 41.4962 21.603 42.5876 22.6917C43.6791 23.7804 44.2837 25.2264 44.2837 26.7674V29.6092C44.2837 31.1501 43.6791 32.6017 42.5876 33.6904C41.4962 34.7792 40.0464 35.3821 38.5016 35.3821C36.9567 35.3821 35.5014 34.7792 34.4099 33.6904C33.3184 32.6017 32.7195 31.1501 32.7195 29.6092ZM49.6292 45.7667C49.2821 46.3586 48.7224 46.7829 48.0619 46.9671C44.9721 47.8213 41.1547 48 38.5016 48C35.8428 48 32.031 47.8213 28.9356 46.9671C28.2751 46.7829 27.7154 46.3586 27.3684 45.7667C27.0157 45.1805 26.915 44.4882 27.0717 43.8182L27.9785 40.0217C28.1912 39.1172 28.7845 38.3579 29.6129 37.9336L34.7121 35.2928C35.8204 36.0354 37.1302 36.4318 38.5016 36.4318C39.8673 36.4318 41.1771 36.0354 42.291 35.2928L47.3902 37.9336C48.213 38.3579 48.8063 39.1172 49.0246 40.0217L49.9258 43.8182C50.0881 44.4882 49.9818 45.1805 49.6292 45.7667Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3866 37.2997) rotate(70.4515) scale(22.0216 22.0213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3864 37.3003) rotate(70.451) scale(22.0215 22.0217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2387 54.9513) rotate(70.4501) scale(0.865666 0.865651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8944 36.8063) rotate(75.0008) scale(22.0218 22.0218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8494 56.81) rotate(75.0122) scale(0.982098 0.982094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3949 36.5193) rotate(81.8367) scale(22.0216 22.0218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0204 58.8609) rotate(81.8435) scale(1.11566 1.11567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3424 37.6076) rotate(97.0596) scale(22.0209 22.0207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2229 61.0708) rotate(97.0591) scale(1.11543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3861 37.2999) rotate(70.4514) scale(22.022 22.022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2176 53.0829) rotate(70.4516) scale(0.774521 0.774522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3871 37.3008) rotate(70.4514) scale(22.0203 22.0205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.0054 51.2296) rotate(70.44) scale(0.682913 0.682902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.563 37.2997) rotate(109.549) scale(22.0227 22.0224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5618 37.3003) rotate(109.549) scale(22.0215 22.0215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7099 54.9513) rotate(109.55) scale(0.865667 0.865657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0532 36.8063) rotate(104.999) scale(22.0218 22.0218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0985 56.81) rotate(104.988) scale(0.982098 0.982099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5523 36.5188) rotate(98.1633) scale(22.0216 22.0218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9271 58.8609) rotate(98.1565) scale(1.11566 1.11567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.605 37.607) rotate(82.9405) scale(22.0209 22.0205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7253 61.0708) rotate(82.9409) scale(1.11543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.561 37.2999) rotate(109.548) scale(22.022 22.0219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7302 53.0829) rotate(109.548) scale(0.774521 0.774522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5615 37.3008) rotate(109.548) scale(22.0208 22.021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_39_2316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9425 51.2296) rotate(109.56) scale(0.682913 0.682901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_2316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.68fd8df22eb61c4f242f7bf7c7c397e9.svg";
export { ForwardRef as ReactComponent };